// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"60220ad0","847":"1baa264a"}[chunkId] + ".chunk.css";
};